import ContentPasteSearchSharpIcon from '@mui/icons-material/ContentPasteSearchSharp'
import EventsList from 'resources/events/EventsList'

const resource = {
  list: EventsList,
  icon: ContentPasteSearchSharpIcon
}

export default resource
